import React from "react";

// Section A: public. The language-switch control on a content page —
// only rendered when the item actually has BOTH a Persian and an
// English version written (see ArticleDetailPage.js/TopicDetailPage.js/
// IssueTopicDetailPage.js) — a page with only one language has nothing
// to switch to.
//
// A two-segment pill, matching the site's editorial copper/paper
// palette (see .metadata-trigger, which it sits next to in
// .content-metadata-row) instead of the earlier sun/moon day-night
// motif. Both language names are always visible and directly
// clickable — no "target language" label trick needed. The segment
// order is fixed left-to-right (فارسی first) regardless of which
// language is currently active, so the control doesn't visually
// reflow depending on the surrounding page's own rtl/ltr.
function LanguageSwitcher({ activeLang, onChange, hasFa, hasEn }) {
  if (!hasFa || !hasEn) return null;

  return (
    <div
      className={`language-toggle${activeLang === "en" ? " language-toggle--active-en" : ""}`}
      role="group"
      aria-label="زبان محتوا"
    >
      <span className="language-toggle-highlight" aria-hidden="true" />
      <button
        type="button"
        className={`language-toggle-option${activeLang === "fa" ? " language-toggle-option--active" : ""}`}
        onClick={() => onChange("fa")}
        aria-pressed={activeLang === "fa"}
        dir="rtl"
      >
        فارسی
      </button>
      <button
        type="button"
        className={`language-toggle-option${activeLang === "en" ? " language-toggle-option--active" : ""}`}
        onClick={() => onChange("en")}
        aria-pressed={activeLang === "en"}
        dir="ltr"
      >
        English
      </button>
    </div>
  );
}

export default LanguageSwitcher;
